import { MappableModel } from './mappable-model'

export class Ethnicity extends MappableModel {
  public id: number
  public code: string
  public name: string
}
